/* eslint-disable camelcase */
// @ts-check
import { TCFVersion2_2_SupportedPurposeLI } from '../utils/policyVersion'
import { consentOrPayDisplayPurposes } from './display-purposes'
/** @import {UserPrefs} from './user-preference' */

/**
 * @param {import('../ui/Ui').CmpModelForUi} cmpModel
 * @param {boolean} isNewUser
 * @returns {UserPrefs}
 */
export const consentOrPayPreferences = (cmpModel, isNewUser) => {
  const mutablePurposes = consentOrPayDisplayPurposes
    .filter(
      ({ type, isConsentImmutable }) => type === 'stacks' && !isConsentImmutable
    )
    .map(({ id }) => cmpModel.tcModel.gvl.stacks[id].purposes)
    .flat()
    .map(String)

  const purposes = Object.keys(cmpModel.tcModel.gvl.purposes).reduce(
    (acc, id) => {
      const isMutable = mutablePurposes.includes(id)
      const consent = !isNewUser && isMutable ? cmpModel.tcModel.purposeConsents.has(parseInt(id)) : !mutablePurposes.includes(id)
      acc[id] = TCFVersion2_2_SupportedPurposeLI.includes(parseInt(id))
        ? { consent, legInterest: isNewUser || cmpModel.tcModel.purposeLegitimateInterests.has(parseInt(id)) }
        : { consent }
      return acc
    },
    /** @type {Record<string, {consent: boolean, legInterest?: boolean}>} */ ({})
  )

  const vendors = Object.values(cmpModel.tcModel.gvl.vendors)
    .filter(({ deletedDate }) => !deletedDate)
    .reduce((acc, vendor) => {
      acc[vendor.id] = {}
      if (vendor.legIntPurposes.length) {
        acc[vendor.id].legInterest = isNewUser || cmpModel.tcModel.vendorLegitimateInterests.has(vendor.id)
      }
      if (vendor.purposes.length) {
        acc[vendor.id].consent = true
      }
      return acc
    }, /** @type {Record<string, {consent?: boolean, legInterest?: boolean}>} */ ({}))

  return {
    purposes,
    vendors,
    nonTcfVendors: cmpModel.acmVendors.vendorIds.reduce((acc, id) => {
      acc[id] = { consent: true }
      return acc
    }, /** @type {Record<string, {consent: boolean}>} */ ({})),
    nonRegisteredVendors: cmpModel.nonRegisteredVendors.vendorIds.reduce(
      (acc, id) => {
        acc[id] = { consent: true }
        return acc
      },
      /** @type {Record<string, {consent: boolean}>} */ ({})),
    specialFeatures: {
      1: { optIn: true },
      2: { optIn: true }
    }
  }
}
